import { render, staticRenderFns } from "./CardEmptyResultSearch.vue?vue&type=template&id=ab749608&"
import script from "./CardEmptyResultSearch.vue?vue&type=script&lang=js&"
export * from "./CardEmptyResultSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports